import { render, staticRenderFns } from "./SubscriptionLevels.vue?vue&type=template&id=b00480a0&"
import script from "./SubscriptionLevels.vue?vue&type=script&lang=js&"
export * from "./SubscriptionLevels.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionLevels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports